// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CustomSidebar from "../../../pricing-dashboard/view/components/library/reuseable-components/CustomSidebar.bs.js";
import * as EditOrderSidebar from "./sidebars/EditOrderSidebar.bs.js";
import * as ConfirmationModal from "../../../pricing-dashboard/view/components/components/sidebars/ConfirmationModal.bs.js";

function EditOrderContainer$CloseModalConfirmation(Props) {
  var isOpen = Props.isOpen;
  var onCancel = Props.onCancel;
  var onSubmit = Props.onSubmit;
  return React.createElement(ConfirmationModal.make, {
              title: "Discard Changes",
              isOpen: isOpen,
              onConfirmCb: onSubmit,
              onCancelCb: onCancel,
              confirm_button_title: "Yes, Discard",
              cancel_button_title: "No, Cancel",
              children: "You are about to leave this page. All the changes will be lost. Are you sure you wish to exit?"
            });
}

var CloseModalConfirmation = {
  make: EditOrderContainer$CloseModalConfirmation
};

function EditOrderContainer(Props) {
  var crn = Props.crn;
  var order = Props.order;
  var user = Props.user;
  var is_editorder_sidebar_open = Props.is_editorder_sidebar_open;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var openSnackbar = Props.openSnackbar;
  var match = React.useState(function () {
        return false;
      });
  var changeDiscardModalState = match[1];
  return React.createElement("div", undefined, React.createElement(CustomSidebar.make, {
                  is_open: is_editorder_sidebar_open,
                  on_back_drop_click: (function (param) {
                      return Curry._1(changeDiscardModalState, (function (param) {
                                    return true;
                                  }));
                    }),
                  children: React.createElement(EditOrderSidebar.make, {
                        crn: crn,
                        order: order,
                        user: user,
                        toggleEditOrderSidebar: toggleEditOrderSidebar,
                        changeDiscardModalState: changeDiscardModalState,
                        openSnackbar: openSnackbar
                      })
                }), React.createElement(EditOrderContainer$CloseModalConfirmation, {
                  isOpen: match[0],
                  onCancel: (function (param) {
                      return Curry._1(changeDiscardModalState, (function (param) {
                                    return false;
                                  }));
                    }),
                  onSubmit: (function (param) {
                      Curry._1(toggleEditOrderSidebar, undefined);
                      return Curry._1(changeDiscardModalState, (function (param) {
                                    return false;
                                  }));
                    })
                }));
}

var make = EditOrderContainer;

export {
  CloseModalConfirmation ,
  make ,
  
}
/* react Not a pure module */
